import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

interface RHFTimePickerProps {
  name: string;
  label?: string;
  format?: string;
  disabled?: boolean;
  placeholder?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  timeSteps?: { minutes?: number; hours?: number };
  minutesStep?: number;
  [key: string]: any;
}

export const RHFTimePicker = React.memo(({
  name,
  label,
  format = "HH:mm",
  disabled = false,
  placeholder,
  size = 'medium',
  fullWidth = true,
  timeSteps,
  minutesStep,
  ...other
}: RHFTimePickerProps) => {
  const { control } = useFormContext();

  // Handle timeSteps: use timeSteps if provided, otherwise convert minutesStep
  const finalTimeSteps = timeSteps || (minutesStep ? { minutes: minutesStep } : undefined);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div className="time-picker">
          <TimePicker
            label={label}
            value={field.value}
            onChange={field.onChange}
            format={format}
            disabled={disabled}
            {...(finalTimeSteps && { timeSteps: finalTimeSteps })}
            slotProps={{
              textField: {
                placeholder,
                size,
                fullWidth,
                sx: {
                  '& .MuiOutlinedInput-root': {
                    height: '40px',
                    borderRadius: '8px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#C8CEE3 !important',
                      borderRadius: '8px',
                      borderWidth: '1px !important',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#C8CEE3 !important',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#C8CEE3 !important',
                      borderWidth: '1px !important',
                    },
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#FF0000 !important',
                    },
                  },
                },
                error: !!error,
                helperText: error?.message,
                ...other,
              },
            }}
          />
        </div>
      )}
    />
  );
});
